import styled from 'styled-components';
import React from 'react';

interface TooltipProps extends React.AllHTMLAttributes<HTMLElement> {
  tooltip: string;
  caption?: string;
  width?: string;
}

const StyledTooltip = styled.div<{
  width?: string;
}>`
  visibility: hidden;
  position: absolute;
  z-index: 2;
  width: ${props => props.width};
  background-color: ${({ theme }) => theme.colors.NEUTRAL.N0};
  color: ${({ theme }) => theme.colors.LABEL};
  border: 1px solid ${({ theme }) => theme.colors.BORDER};
  box-shadow: 0 1px 3px 1px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  padding: 5px 10px;
  top: 25px;
  left: 20px;
  word-wrap: break-word;
  height: auto;
  white-space: break-spaces;

  ::before {
    top: -5%;
    left: 45%;
  }

  hr {
    display: block;
    margin: 0.5em auto;
    border-style: solid;
    border-width: 1px;
    border-color: ${({ theme }) => theme.colors.NEUTRAL.N300};
  }
`;
const StyledCaption = styled.span`
  display: block;
  font-size: 12px;
`;

const TooltipComponent = ({
  tooltip,
  caption,
  width = 'auto',
}: TooltipProps) => {
  return (
    <StyledTooltip width={width} className="tooltip">
      {tooltip}
      {caption ? <hr /> : null}
      <StyledCaption>{caption}</StyledCaption>
    </StyledTooltip>
  );
};

export default TooltipComponent;
